import { env } from '../globals/config/env';

export type APIConfig = {
  BACKEND_URL: string;
  PROJECTBUILDER_DOMAIN: string;
};

export const API_CONFIG: APIConfig = {
  BACKEND_URL: env('BACKEND_URL', 'BACKEND_URL_NOT_PROVIDED'),
  PROJECTBUILDER_DOMAIN: env('PROJECTBUILDER_DOMAIN', ''),
};
